import React from 'react'
import { PriceCard } from './PriceCard'
import { Body, Box, H4 } from '../layout'
import { Bullets } from './Bullets'
import { PriceTiers } from './PriceTiers'
import { enterprise } from '../../prices'
import { PartnerPricing } from './PartnerPricing'

export const PriceCards = ({ partner, submitted, onPartnerSelected }) => {

  return (
    <Box
      container
      fullWidth
      maxWidth={(!partner || submitted) && 1045}
      px={24}
      gap={24}
      justifyContent={(!partner || submitted) ? 'space-between' : 'start'}
      alignItems="center"
      className="mobile-column"
    >
      {!partner && <>
        <PriceCard>
          <H4>Single team</H4>
          <Box column gap={4}>
            <H4>$360 <Body size={12} bold={false} style={{ marginLeft: -6 }}>p/a</Body></H4>
            <Body size={12} lineHeight="normal">$30 / month</Body>
          </Box>
          <Bullets
            items={[
              'Unlimited seats within a team',
              'Run unlimited Squizzes (assessments)',
              'Real time results',
              'Detailed data and analytics',
              'Review progress over time',
              'Compare results with our global database'
            ]}
            size={16}
          />
          <Box container fullWidth fullHeight>
            <Box position="absolute" bottom={0} fullWidth>
              <a style={{ width: "280px" }} className="button-anchor" href="/shivoo/">Get started</a>
            </Box>
          </Box>
        </PriceCard>

        <PriceCard>
          <H4>Multiple teams</H4>
          <PriceTiers tiers={enterprise} />
          <Box column gap={16}>
            <Body size={16} bold>Includes single team, plus:</Body>
            <Bullets
              items={[
                'Manage teams & members',
                'Assign Team Leaders',
                'Compare teams within your organization',
                'Organizational statistics'
              ]}
              size={16}
            />
          </Box>
          <Box container fullWidth fullHeight>
            <Box position="absolute" bottom={0} fullWidth>
              <a style={{ width: "280px" }} className="button-anchor" href="/shivoo/">Get started</a>
            </Box>
          </Box>
        </PriceCard>
      </>}

      <PriceCard left={partner && !submitted} className={partner ? 'desktop-only' : undefined}>
        <H4>Partners</H4>
        <Body align="left" alt weight={600} lineHeight="1.1" size={16}>
          For facilitators, trainers and team coaches
        </Body>

        <Box column gap={16}>
          <Body align="left" size={16} bold>Includes everything, plus:</Body>
          <Bullets
            items={[
              'Manage clients',
              'Access to the P&H partner facilitator network'
            ]}
            size={16}
          />
        </Box>
        {!partner &&
          <Box position="absolute" bottom={16} fullWidth>
            <button style={{ width: "280px" }} onClick={() => onPartnerSelected(true)}>Learn more</button>
          </Box>
        }
      </PriceCard>

      {(partner && submitted) &&
        <PartnerPricing />
      }
    </Box>
  )
}